import { useRoutes } from "react-router-dom";

import AdminRoutes from "./AdminRoutes";
import CheckInRoute from "./CheckInRoute";
import LoginRoutes from "./LoginRoutes";
import PartnerRoutes from "referralPortal/PartnerRoutes";

export default function ThemeRoutes() {
  return useRoutes([AdminRoutes, PartnerRoutes, LoginRoutes, CheckInRoute]);
}
